/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { ClimateRelatedTargets } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function ClimateRelatedTargetsClimateRelatedTargetCreateForm(
  props
) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    TargetName: "",
    TargetDescription: "",
    TargetValue: "",
    TargetUnit: "",
    TargetObjective: "",
    ApplicableEntityPart: "",
    TargetTimeframeStartDate: "",
    TargetTimeframeEndDate: "",
    TargetBaseYear: "",
    TargetType: "",
    InformedByInternationalAgreement: "",
    TargetReviewProcessName: "",
    TargetReviewProcessDescription: "",
    TargetReviewProcessFrequency: "",
  };
  const [TargetName, setTargetName] = React.useState(initialValues.TargetName);
  const [TargetDescription, setTargetDescription] = React.useState(
    initialValues.TargetDescription
  );
  const [TargetValue, setTargetValue] = React.useState(
    initialValues.TargetValue
  );
  const [TargetUnit, setTargetUnit] = React.useState(initialValues.TargetUnit);
  const [TargetObjective, setTargetObjective] = React.useState(
    initialValues.TargetObjective
  );
  const [ApplicableEntityPart, setApplicableEntityPart] = React.useState(
    initialValues.ApplicableEntityPart
  );
  const [TargetTimeframeStartDate, setTargetTimeframeStartDate] =
    React.useState(initialValues.TargetTimeframeStartDate);
  const [TargetTimeframeEndDate, setTargetTimeframeEndDate] = React.useState(
    initialValues.TargetTimeframeEndDate
  );
  const [TargetBaseYear, setTargetBaseYear] = React.useState(
    initialValues.TargetBaseYear
  );
  const [TargetType, setTargetType] = React.useState(initialValues.TargetType);
  const [
    InformedByInternationalAgreement,
    setInformedByInternationalAgreement,
  ] = React.useState(initialValues.InformedByInternationalAgreement);
  const [TargetReviewProcessName, setTargetReviewProcessName] = React.useState(
    initialValues.TargetReviewProcessName
  );
  const [TargetReviewProcessDescription, setTargetReviewProcessDescription] =
    React.useState(initialValues.TargetReviewProcessDescription);
  const [TargetReviewProcessFrequency, setTargetReviewProcessFrequency] =
    React.useState(initialValues.TargetReviewProcessFrequency);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setTargetName(initialValues.TargetName);
    setTargetDescription(initialValues.TargetDescription);
    setTargetValue(initialValues.TargetValue);
    setTargetUnit(initialValues.TargetUnit);
    setTargetObjective(initialValues.TargetObjective);
    setApplicableEntityPart(initialValues.ApplicableEntityPart);
    setTargetTimeframeStartDate(initialValues.TargetTimeframeStartDate);
    setTargetTimeframeEndDate(initialValues.TargetTimeframeEndDate);
    setTargetBaseYear(initialValues.TargetBaseYear);
    setTargetType(initialValues.TargetType);
    setInformedByInternationalAgreement(
      initialValues.InformedByInternationalAgreement
    );
    setTargetReviewProcessName(initialValues.TargetReviewProcessName);
    setTargetReviewProcessDescription(
      initialValues.TargetReviewProcessDescription
    );
    setTargetReviewProcessFrequency(initialValues.TargetReviewProcessFrequency);
    setErrors({});
  };
  const validations = {
    TargetName: [],
    TargetDescription: [],
    TargetValue: [],
    TargetUnit: [],
    TargetObjective: [],
    ApplicableEntityPart: [],
    TargetTimeframeStartDate: [],
    TargetTimeframeEndDate: [],
    TargetBaseYear: [],
    TargetType: [],
    InformedByInternationalAgreement: [],
    TargetReviewProcessName: [],
    TargetReviewProcessDescription: [],
    TargetReviewProcessFrequency: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          TargetName,
          TargetDescription,
          TargetValue,
          TargetUnit,
          TargetObjective,
          ApplicableEntityPart,
          TargetTimeframeStartDate,
          TargetTimeframeEndDate,
          TargetBaseYear,
          TargetType,
          InformedByInternationalAgreement,
          TargetReviewProcessName,
          TargetReviewProcessDescription,
          TargetReviewProcessFrequency,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new ClimateRelatedTargets(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "ClimateRelatedTargetsClimateRelatedTargetCreateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Related Targets"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="AASB S2 paragraph 33 a-h."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Enter data about a quantitative and/or qualitative climate-related target you have set to monitor progress towards achieving your strategic goals, including any target you are required to meet by law or regulation."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextField
        label="Target name"
        isRequired={false}
        isReadOnly={false}
        value={TargetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName: value,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetName ?? value;
          }
          if (errors.TargetName?.hasError) {
            runValidationTasks("TargetName", value);
          }
          setTargetName(value);
        }}
        onBlur={() => runValidationTasks("TargetName", TargetName)}
        errorMessage={errors.TargetName?.errorMessage}
        hasError={errors.TargetName?.hasError}
        {...getOverrideProps(overrides, "TargetName")}
      ></TextField>
      <TextAreaField
        label="Target description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription: value,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetDescription ?? value;
          }
          if (errors.TargetDescription?.hasError) {
            runValidationTasks("TargetDescription", value);
          }
          setTargetDescription(value);
        }}
        onBlur={() =>
          runValidationTasks("TargetDescription", TargetDescription)
        }
        errorMessage={errors.TargetDescription?.errorMessage}
        hasError={errors.TargetDescription?.hasError}
        {...getOverrideProps(overrides, "TargetDescription")}
      ></TextAreaField>
      <Text
        children="Define the metric used to set the target"
        {...getOverrideProps(overrides, "SectionalElement6")}
      ></Text>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <TextField
          label="Target value"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={TargetValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                TargetName,
                TargetDescription,
                TargetValue: value,
                TargetUnit,
                TargetObjective,
                ApplicableEntityPart,
                TargetTimeframeStartDate,
                TargetTimeframeEndDate,
                TargetBaseYear,
                TargetType,
                InformedByInternationalAgreement,
                TargetReviewProcessName,
                TargetReviewProcessDescription,
                TargetReviewProcessFrequency,
              };
              const result = onChange(modelFields);
              value = result?.TargetValue ?? value;
            }
            if (errors.TargetValue?.hasError) {
              runValidationTasks("TargetValue", value);
            }
            setTargetValue(value);
          }}
          onBlur={() => runValidationTasks("TargetValue", TargetValue)}
          errorMessage={errors.TargetValue?.errorMessage}
          hasError={errors.TargetValue?.hasError}
          {...getOverrideProps(overrides, "TargetValue")}
        ></TextField>
        <SelectField
          label="Target unit"
          placeholder="Please select an option"
          isDisabled={false}
          value={TargetUnit}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                TargetName,
                TargetDescription,
                TargetValue,
                TargetUnit: value,
                TargetObjective,
                ApplicableEntityPart,
                TargetTimeframeStartDate,
                TargetTimeframeEndDate,
                TargetBaseYear,
                TargetType,
                InformedByInternationalAgreement,
                TargetReviewProcessName,
                TargetReviewProcessDescription,
                TargetReviewProcessFrequency,
              };
              const result = onChange(modelFields);
              value = result?.TargetUnit ?? value;
            }
            if (errors.TargetUnit?.hasError) {
              runValidationTasks("TargetUnit", value);
            }
            setTargetUnit(value);
          }}
          onBlur={() => runValidationTasks("TargetUnit", TargetUnit)}
          errorMessage={errors.TargetUnit?.errorMessage}
          hasError={errors.TargetUnit?.hasError}
          {...getOverrideProps(overrides, "TargetUnit")}
        >
          <option
            children="Employees"
            value="Employees"
            {...getOverrideProps(overrides, "TargetUnitoption0")}
          ></option>
          <option
            children="Kg"
            value="Kg"
            {...getOverrideProps(overrides, "TargetUnitoption1")}
          ></option>
          <option
            children="Kw"
            value="Kw"
            {...getOverrideProps(overrides, "TargetUnitoption2")}
          ></option>
          <option
            children="Kwh"
            value="Kwh"
            {...getOverrideProps(overrides, "TargetUnitoption3")}
          ></option>
          <option
            children="Litres"
            value="Litres"
            {...getOverrideProps(overrides, "TargetUnitoption4")}
          ></option>
          <option
            children="Metres cubed"
            value="MetresCubed"
            {...getOverrideProps(overrides, "TargetUnitoption5")}
          ></option>
          <option
            children="Million dollars revenue"
            value="MillionDollarsRevenue"
            {...getOverrideProps(overrides, "TargetUnitoption6")}
          ></option>
          <option
            children="Nights"
            value="Nights"
            {...getOverrideProps(overrides, "TargetUnitoption7")}
          ></option>
          <option
            children="Passenger per km"
            value="PassengerPerKm"
            {...getOverrideProps(overrides, "TargetUnitoption8")}
          ></option>
          <option
            children="Per capita"
            value="PerCapita"
            {...getOverrideProps(overrides, "TargetUnitoption9")}
          ></option>
          <option
            children="Percentage"
            value="Percentage"
            {...getOverrideProps(overrides, "TargetUnitoption10")}
          ></option>
          <option
            children="Quantity"
            value="Quantity"
            {...getOverrideProps(overrides, "TargetUnitoption11")}
          ></option>
          <option
            children="Tonnes"
            value="Tonnes"
            {...getOverrideProps(overrides, "TargetUnitoption12")}
          ></option>
          <option
            children="Tonnes per km"
            value="TonnesPerKm"
            {...getOverrideProps(overrides, "TargetUnitoption13")}
          ></option>
        </SelectField>
      </Grid>
      <SelectField
        label="Target objective"
        placeholder="Please select an option"
        isDisabled={false}
        value={TargetObjective}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective: value,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetObjective ?? value;
          }
          if (errors.TargetObjective?.hasError) {
            runValidationTasks("TargetObjective", value);
          }
          setTargetObjective(value);
        }}
        onBlur={() => runValidationTasks("TargetObjective", TargetObjective)}
        errorMessage={errors.TargetObjective?.errorMessage}
        hasError={errors.TargetObjective?.hasError}
        {...getOverrideProps(overrides, "TargetObjective")}
      >
        <option
          children="Mitigation"
          value="Mitigation"
          {...getOverrideProps(overrides, "TargetObjectiveoption0")}
        ></option>
        <option
          children="Adaptation"
          value="Adaptation"
          {...getOverrideProps(overrides, "TargetObjectiveoption1")}
        ></option>
        <option
          children="Conformance with science based initiatives"
          value="ConformanceWithScienceBasedInitiatives"
          {...getOverrideProps(overrides, "TargetObjectiveoption2")}
        ></option>
      </SelectField>
      <TextAreaField
        label="Describe which part of your organisation the target applies to (e.g. the whole organisation, or part of the organisation such as a specific business unit or specific geographical region)"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart: value,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.ApplicableEntityPart ?? value;
          }
          if (errors.ApplicableEntityPart?.hasError) {
            runValidationTasks("ApplicableEntityPart", value);
          }
          setApplicableEntityPart(value);
        }}
        onBlur={() =>
          runValidationTasks("ApplicableEntityPart", ApplicableEntityPart)
        }
        errorMessage={errors.ApplicableEntityPart?.errorMessage}
        hasError={errors.ApplicableEntityPart?.hasError}
        {...getOverrideProps(overrides, "ApplicableEntityPart")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid10")}
      >
        <TextField
          label="Target period start date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={TargetTimeframeStartDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                TargetName,
                TargetDescription,
                TargetValue,
                TargetUnit,
                TargetObjective,
                ApplicableEntityPart,
                TargetTimeframeStartDate: value,
                TargetTimeframeEndDate,
                TargetBaseYear,
                TargetType,
                InformedByInternationalAgreement,
                TargetReviewProcessName,
                TargetReviewProcessDescription,
                TargetReviewProcessFrequency,
              };
              const result = onChange(modelFields);
              value = result?.TargetTimeframeStartDate ?? value;
            }
            if (errors.TargetTimeframeStartDate?.hasError) {
              runValidationTasks("TargetTimeframeStartDate", value);
            }
            setTargetTimeframeStartDate(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "TargetTimeframeStartDate",
              TargetTimeframeStartDate
            )
          }
          errorMessage={errors.TargetTimeframeStartDate?.errorMessage}
          hasError={errors.TargetTimeframeStartDate?.hasError}
          {...getOverrideProps(overrides, "TargetTimeframeStartDate")}
        ></TextField>
        <TextField
          label="Target period end date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={TargetTimeframeEndDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                TargetName,
                TargetDescription,
                TargetValue,
                TargetUnit,
                TargetObjective,
                ApplicableEntityPart,
                TargetTimeframeStartDate,
                TargetTimeframeEndDate: value,
                TargetBaseYear,
                TargetType,
                InformedByInternationalAgreement,
                TargetReviewProcessName,
                TargetReviewProcessDescription,
                TargetReviewProcessFrequency,
              };
              const result = onChange(modelFields);
              value = result?.TargetTimeframeEndDate ?? value;
            }
            if (errors.TargetTimeframeEndDate?.hasError) {
              runValidationTasks("TargetTimeframeEndDate", value);
            }
            setTargetTimeframeEndDate(value);
          }}
          onBlur={() =>
            runValidationTasks("TargetTimeframeEndDate", TargetTimeframeEndDate)
          }
          errorMessage={errors.TargetTimeframeEndDate?.errorMessage}
          hasError={errors.TargetTimeframeEndDate?.hasError}
          {...getOverrideProps(overrides, "TargetTimeframeEndDate")}
        ></TextField>
      </Grid>
      <TextField
        label="Target base year"
        isRequired={false}
        isReadOnly={false}
        value={TargetBaseYear}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear: value,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetBaseYear ?? value;
          }
          if (errors.TargetBaseYear?.hasError) {
            runValidationTasks("TargetBaseYear", value);
          }
          setTargetBaseYear(value);
        }}
        onBlur={() => runValidationTasks("TargetBaseYear", TargetBaseYear)}
        errorMessage={errors.TargetBaseYear?.errorMessage}
        hasError={errors.TargetBaseYear?.hasError}
        {...getOverrideProps(overrides, "TargetBaseYear")}
      ></TextField>
      <SelectField
        label="Target type"
        placeholder="Please select an option"
        isDisabled={false}
        value={TargetType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType: value,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetType ?? value;
          }
          if (errors.TargetType?.hasError) {
            runValidationTasks("TargetType", value);
          }
          setTargetType(value);
        }}
        onBlur={() => runValidationTasks("TargetType", TargetType)}
        errorMessage={errors.TargetType?.errorMessage}
        hasError={errors.TargetType?.hasError}
        {...getOverrideProps(overrides, "TargetType")}
      >
        <option
          children="Absolute target"
          value="AbsoluteTarget"
          {...getOverrideProps(overrides, "TargetTypeoption0")}
        ></option>
        <option
          children="Intensity target"
          value="IntensityTarget"
          {...getOverrideProps(overrides, "TargetTypeoption1")}
        ></option>
      </SelectField>
      <TextAreaField
        label="Describe how your target is informed by the latest international agreement on climate change, including any jurisdictional commitments arising from that agreement"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement: value,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.InformedByInternationalAgreement ?? value;
          }
          if (errors.InformedByInternationalAgreement?.hasError) {
            runValidationTasks("InformedByInternationalAgreement", value);
          }
          setInformedByInternationalAgreement(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "InformedByInternationalAgreement",
            InformedByInternationalAgreement
          )
        }
        errorMessage={errors.InformedByInternationalAgreement?.errorMessage}
        hasError={errors.InformedByInternationalAgreement?.hasError}
        {...getOverrideProps(overrides, "InformedByInternationalAgreement")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <TextField
        label="Target review process name"
        isRequired={false}
        isReadOnly={false}
        value={TargetReviewProcessName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName: value,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetReviewProcessName ?? value;
          }
          if (errors.TargetReviewProcessName?.hasError) {
            runValidationTasks("TargetReviewProcessName", value);
          }
          setTargetReviewProcessName(value);
        }}
        onBlur={() =>
          runValidationTasks("TargetReviewProcessName", TargetReviewProcessName)
        }
        errorMessage={errors.TargetReviewProcessName?.errorMessage}
        hasError={errors.TargetReviewProcessName?.hasError}
        {...getOverrideProps(overrides, "TargetReviewProcessName")}
      ></TextField>
      <TextField
        label="Target review process description"
        isRequired={false}
        isReadOnly={false}
        value={TargetReviewProcessDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription: value,
              TargetReviewProcessFrequency,
            };
            const result = onChange(modelFields);
            value = result?.TargetReviewProcessDescription ?? value;
          }
          if (errors.TargetReviewProcessDescription?.hasError) {
            runValidationTasks("TargetReviewProcessDescription", value);
          }
          setTargetReviewProcessDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "TargetReviewProcessDescription",
            TargetReviewProcessDescription
          )
        }
        errorMessage={errors.TargetReviewProcessDescription?.errorMessage}
        hasError={errors.TargetReviewProcessDescription?.hasError}
        {...getOverrideProps(overrides, "TargetReviewProcessDescription")}
      ></TextField>
      <SelectField
        label="Target review process frequency"
        placeholder="Please select an option"
        isDisabled={false}
        value={TargetReviewProcessFrequency}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              TargetName,
              TargetDescription,
              TargetValue,
              TargetUnit,
              TargetObjective,
              ApplicableEntityPart,
              TargetTimeframeStartDate,
              TargetTimeframeEndDate,
              TargetBaseYear,
              TargetType,
              InformedByInternationalAgreement,
              TargetReviewProcessName,
              TargetReviewProcessDescription,
              TargetReviewProcessFrequency: value,
            };
            const result = onChange(modelFields);
            value = result?.TargetReviewProcessFrequency ?? value;
          }
          if (errors.TargetReviewProcessFrequency?.hasError) {
            runValidationTasks("TargetReviewProcessFrequency", value);
          }
          setTargetReviewProcessFrequency(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "TargetReviewProcessFrequency",
            TargetReviewProcessFrequency
          )
        }
        errorMessage={errors.TargetReviewProcessFrequency?.errorMessage}
        hasError={errors.TargetReviewProcessFrequency?.hasError}
        {...getOverrideProps(overrides, "TargetReviewProcessFrequency")}
      >
        <option
          children="Daily"
          value="Daily"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption0"
          )}
        ></option>
        <option
          children="Weekly"
          value="Weekly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption1"
          )}
        ></option>
        <option
          children="Fortnightly"
          value="Fortnightly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption2"
          )}
        ></option>
        <option
          children="Monthly"
          value="Monthly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption3"
          )}
        ></option>
        <option
          children="Quarterly"
          value="Quarterly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption4"
          )}
        ></option>
        <option
          children="Half yearly"
          value="HalfYearly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption5"
          )}
        ></option>
        <option
          children="Yearly"
          value="Yearly"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption6"
          )}
        ></option>
        <option
          children="Every two years"
          value="EveryTwoYears"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption7"
          )}
        ></option>
        <option
          children="Every three years"
          value="EveryThreeYears"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption8"
          )}
        ></option>
        <option
          children="Adhoc"
          value="Adhoc"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption9"
          )}
        ></option>
        <option
          children="Never"
          value="Never"
          {...getOverrideProps(
            overrides,
            "TargetReviewProcessFrequencyoption10"
          )}
        ></option>
      </SelectField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
